const user = require("./user.service");
const otp = require("./otp.service");
const API = require("./api.utils");
const consultation = require("./consulatation.service");
const appointments = require("./appointment.service");
const file = require("./file.service");
const marketplace = require("./marketplace");
const alerts = require("./alert.service");
const kyc = require("./kyc-service");
module.exports = {
  user,
  otp,
  API,
  consultation,
  appointments,
  file,
  marketplace,
  alerts,
  kyc,
};
